import React from "react";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { useLandingTheme } from "../../LandingThemeContext";
import { Rule, ThemedContainer } from "./ThemedLayout";

// Six marks that fit the container without clipping, at one ink and one height.
const UNIVERSITY_LOGOS: Array<{ file: string; name: string }> = [
  { file: "harvard.webp", name: "Harvard University" },
  { file: "yale.webp", name: "Yale University" },
  { file: "columbia.webp", name: "Columbia University" },
  { file: "princeton.webp", name: "Princeton University" },
  { file: "umich.webp", name: "University of Michigan" },
  { file: "stanford.webp", name: "Stanford University" },
];

// A ruled band directly under the quote: caption on the left, the marks spread across the rest.
export function ThemedLogoStrip() {
  const theme = useLandingTheme();
  const inkFilter = theme.isDark ? "grayscale(1) invert(1) contrast(1.5)" : "grayscale(1) contrast(1.7)";
  return (
    <Box as="section" mt={{ base: "48px", lg: "56px" }}>
      <ThemedContainer>
        <Rule />
        <Flex align="center" gap={{ base: "16px", md: "40px" }} py="22px" direction={{ base: "column", md: "row" }}>
          <Text fontFamily={theme.font.body} fontSize="13px" fontWeight={600} color={theme.color.muted} whiteSpace="nowrap" flexShrink={0}>
            Used by students at
          </Text>
          <Flex flex="1" minW={0} justify="space-between" align="center" gap="24px" wrap={{ base: "wrap", md: "nowrap" }}>
            {UNIVERSITY_LOGOS.map((universityLogo) => (
              <Image
                key={universityLogo.file}
                loading="lazy"
                src={`/images/landing/universities/${universityLogo.file}`}
                alt={universityLogo.name}
                h="36px"
                w="130px"
                objectFit="contain"
                filter={inkFilter}
                opacity={theme.isDark ? 0.6 : 0.85}
                mixBlendMode={theme.isDark ? "screen" : "multiply"}
              />
            ))}
          </Flex>
        </Flex>
        <Rule />
      </ThemedContainer>
    </Box>
  );
}
